import { Menu } from '@mui/material'
import React from 'react'
import ListMenu from '../../../../../commom/ListMenu'
import { useParams } from 'react-router-dom';
import ElementDialog from '../DialogElement/DialogElement';

const MenuElement = ({
  baseElement, setChange,
  data, setData, 
  menuElement, handleMenuElementClose,
  modalElement, setModalElement, setModalChildren 
}) => {
  const { curriculumId, elementId } = useParams();

  return (
    <>
      { modalElement &&
        <ElementDialog
          show={!!modalElement}
          type={modalElement?.type}
          data={{
            ...modalElement?.form?.element,
            parent: modalElement?.form?.parent,
            parentElements: modalElement?.form?.parentElements,
            elementIds: modalElement?.form?.elementIds
          }}
          onClose={() => {
            setModalElement(null)
            setData({})
          }}
          baseElement={baseElement}
          setChange={setChange}
        />
      }
      { menuElement &&
        <Menu
          id={`menuElement-${curriculumId}-${elementId}`}
          MenuListProps={{
            style: { width: '260px' },
            className: "list-menuElement p-0"
          }}
          keepMounted
          open={menuElement.mouseY !== null}
          onClose={handleMenuElementClose}
          anchorReference="anchorPosition"
          anchorPosition={
            menuElement.mouseY !== null && menuElement.mouseX !== null
              ? { top: menuElement.mouseY, left: menuElement.mouseX }
              : undefined
          }
        >
          <ListMenu
            id={`menuElement-list-${curriculumId}-${elementId}`}
            items={[
                { 
                  label: 'Delete',
                  icon: 'trash-alt',
                  permissions: true,
                  onClick: () => setModalElement({
                    type: 'delete',
                    form: data
                  })
                },
                { 
                  divider: true,
                  label: 'Add children',
                  icon: 'plus',
                  permissions: true,
                  onClick: () => setModalChildren({
                    type: 'add children',
                    form: {
                      parent: data.parent,
                      element: {
                        childrenId: data?.children?._id,
                        elementId: data?.element?._id
                      },
                      children: {
                        childrenId: data?.children?._id,
                        elementId: data?.element?._id
                      }
                    }
                  })
                }
              ]
              .filter((item) => item.permissions)
              .map((item) => ({ 
                ...item, 
                onClick: () => {
                  if (item.onClick) {
                    item.onClick()
                  }
                  handleMenuElementClose()
                }
              }))
            } 
          />
        </Menu>   
      }
    </>
  )
}

export default MenuElement